import axios from "axios";
import endPoints from "../../../../../config/endPoints";

export const getAllServiceItemsForServiceApi = async(reqBody) => {
  return axios.post(`${endPoints.serviceItems}`, reqBody);
};

export const searchServiceItemsForServiceApi = async(reqBody) => {
  return axios.post(`${endPoints.serviceItems}/service/search`, reqBody);
};

// export const getAllServiceItemsForServiceApi = async(reqBody) => {
//   return axios.get(`${endPoints.serviceItems}/serviceId`, reqBody);
// };

// export const searchServiceItemsForServiceApi = async(reqBody) => {
//   return axios.post(`${endPoints.serviceItems}/service/search`, reqBody);
// };